/**
 * 登录页：Home4i passkey 登录（整页跳到 Worker 的 /auth/login，登录后回到当前地址）。
 * Worker 开了 DEV_PASSWORD_LOGIN 时（/auth/status 的 dev_login=true）另外显示"开发登录"表单（演示账号）。
 */
import { KeyRound } from "lucide-react";
import { useState, type FormEvent } from "react";
import { devLogin, loginWithHome4i, useSession } from "../../core";
import { Button, TextField } from "../../ui";
import "./login.css";

export function LoginPage() {
  const message = useSession((s) => s.loginMessage);
  const devEnabled = useSession((s) => s.devLogin);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function submitDev(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await devLogin(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  const shownError = error ?? message;

  return (
    <div className="kp-login">
      <header className="kp-login-head">
        <span className="kp-login-logo">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" aria-hidden>
            <path d="M12 2.8l2.75 5.57 6.15.9-4.45 4.33 1.05 6.12L12 16.83l-5.5 2.89 1.05-6.12L3.1 9.27l6.15-.9z" />
          </svg>
        </span>
        <h1>kids-planner 家长端</h1>
        <p>安排时间表、布置学习、发奖励</p>
      </header>

      <div className="kp-login-body">
        <section className="kp-login-card">
          <h2>
            <KeyRound size={22} /> 使用 Home4i 账号登录
          </h2>
          <p className="kp-login-hint">用 passkey（Face ID / Touch ID / 安全密钥）验证，不需要密码。只有获得授权的 Home4i 账号可以登录。</p>
          {shownError && (
            <p className="kp-login-error" role="alert">
              {shownError}
            </p>
          )}
          <Button block onClick={() => loginWithHome4i()}>
            使用 Home4i 登录
          </Button>
        </section>

        {devEnabled && (
          <form className="kp-login-card" onSubmit={submitDev}>
            <h2>开发登录</h2>
            <p className="kp-login-hint">本地开发用：演示账号邮箱密码登录（Worker 开启了 DEV_PASSWORD_LOGIN）。</p>
            <TextField label="邮箱" type="email" autoComplete="username" placeholder="demo@kidsplanner.local" value={email} onChange={setEmail} name="email" />
            <TextField label="密码" type="password" autoComplete="current-password" placeholder="密码" value={password} onChange={setPassword} name="password" />
            <Button type="submit" variant="dark" block busy={busy} disabled={!email || !password}>
              开发登录
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
